module.exports = __webpack_public_path__ + "img/weal4.514a5874.png";